import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { ON_BOARDING_ROUTES } from '../../../utils/constatns';
import {
  convertQuickApplicationToInitialValues, convertToInitialFeeValues,
  formattedQuickApplicationFormValues, getFormattedFormikFeeData,
} from '../../../constants/new-application/quick-application/quick-application-form';
import { Dispatch } from 'react';
import { IAction } from '../merchant-interfaces';
import { merchantActionTypes } from '../action-types';
import { errorHandler } from '../../../utils/newApplicationUtils';
import {
  getFormattedInitialFeeValues,
} from '../../../constants/new-application/quick-application/fee-form';
import { POST } from '../../store-helper';

interface IFetchQuickApplication {
  dispatch: Dispatch<IAction>;
  applicationId: string;
  formik: any;
}
export const fetchQuickApplication = async ({ dispatch, applicationId, formik }: IFetchQuickApplication): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.SET_QUICK_APP_DATA_LOADING, payload: true });
    const { data } = await axios.get(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/quick/${applicationId}`);
    console.log('convertedData---++', data);
    if (data?.record) {
      const convertedData = convertQuickApplicationToInitialValues(data.record);
      console.log('convertedData---', convertedData);
      let convertedFees = {};

      if (data?.record?.fees) {
        const newFees: any = {};

        data?.record?.fees.forEach(el => {
          switch (el.name) {
            case 'Percentage':
              newFees.percentage = el.amount / 100;
              newFees.percentageId = el.id;
              newFees.minFeeAmount = el?.minimumFeeAmount ? el?.minimumFeeAmount / 100 : '';
              break;
            case 'Fee Amount':
              newFees.feeAmount = el.amount / 100;
              newFees.feeAmountId = el.id;
              break;
            case 'Chargeback Fee':
              newFees.chargeback = el.amount / 100;
              newFees.chargebackId = el.id;
              break;
            case 'Refund Fee':
              newFees.refundFee = el.amount / 100;
              newFees.refundFeeId = el.id;
              break;
            case 'Risk Fee':
              newFees.riskFee = el.amount / 100;
              newFees.riskFeeId = el.id;
              break;
          }
        });
        convertedFees = convertToInitialFeeValues(newFees);
      }
      const convertedApplicationData = {
        ...convertedData,
        ...convertedFees
      };
      formik.setValues(convertedApplicationData);
    }
    dispatch({ type: merchantActionTypes.SET_QUICK_APP_DATA, payload: data?.record ?? null });
    dispatch({ type: merchantActionTypes.FETCH_IS_STANDARD_FEE_SELECTED, payload: data?.record?.standardFeeSelected ?? false });
  } catch (e) {
    dispatch({ type: merchantActionTypes.SET_QUICK_APP_DATA_LOADING, payload: false });
    console.log('fetchQuickApplication', e);
  }
};

export const setQuickApplicationDataToDefault = (dispatch: Dispatch<IAction>): void => {
  dispatch({ type: merchantActionTypes.SET_QUICK_APP_DATA, payload: null });
};

type IQuickApplication = {
  dispatch: Dispatch<IAction>;
  formik: any;
  onSuccess?: (applicationId: string, isSend?: boolean) => void;
  isSaveAndSend?: boolean;
}
export const setQuickApplication = async ({ dispatch, formik, onSuccess, isSaveAndSend }: IQuickApplication): Promise<void> => {
  try {
    dispatch({ type: merchantActionTypes.SET_QUICK_APP_LOADING, payload: true });
    const formattedFees = getFormattedFormikFeeData(formik.values);
    console.log('setQuickApplication---', formik.values, formattedQuickApplicationFormValues(formik.values));
    const params = {
      ...formattedQuickApplicationFormValues(formik.values),
      standardFeeSelected: false,
      fees: getFormattedInitialFeeValues(formattedFees),
      saveAndSend: true,
    };

    if (!isSaveAndSend) {
      delete params.saveAndSend;
    }

    console.log('params', params);

    const data = await POST({
      pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/quick`,
      body: params,
      formik,
    });

    dispatch({ type: merchantActionTypes.SET_QUICK_APP_LOADING, payload: false });
    onSuccess(data?.applicationId, isSaveAndSend);
  } catch (e) {
    dispatch({ type: merchantActionTypes.SET_QUICK_APP_LOADING, payload: false });
    console.log('setQuickApplication', e);
    // errorHandler({ e, formik });
  }
};


